const FAVOURITE = "/api/favourites";
const DELETE_FAVOURITE = FAVOURITE + "/delete";

const exportedObject = {
  FAVOURITE,
  DELETE_FAVOURITE,
};

export default exportedObject;
